export enum AuthenticationMethodType {
    impersonate = "13c37a98-26e3-4732-a27a-3a23686c36c3",
    otpViaEmail = "055bc4dd-7546-4bd5-aba2-75089d1a6816",
    otpViaSms = "9f55c3b6-0497-4ae3-8b61-349a741824d8",
    passwordViaEmail = "2570ead3-e83a-4865-a107-8e7d239781d7",
    ssoViaGoogle = "9e2fe1de-214d-4976-9bc2-af0808a19e4c",
    ssoViaMicrosoft = "922f528e-79d7-4518-a88e-7a5f89c29f16",
}
